/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
import axios from 'axios';
import { getAPIUrl, getAPIUrl_solveorder } from './env';
import { decrypt_data } from '../utils';

// const env_xApiKey = process.env.REACT_APP_X_API_KEY;
// const xApiKey = decrypt_data(env_xApiKey);

// const createQueryString = (obj) => {
//   if (!obj) {
//     return '';
//   }
//   const esc = encodeURIComponent;
//   return Object.keys(obj)
//     .map((k) => `${esc(k)}=${esc(obj[k])}`)
//     .join('&');
// };

// const fetchUrl = (urlPath) => {
//   const urlList = {
//     db: '/api/v1',
//   };
//   return urlList[urlPath];
// };

const createHeaders = () => {
  const headers = {
    'Access-Control-Allow-Methods': 'GET',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
  };
  return headers; // Object.assign({}, this.defaultHeaders, headers);
};

const instance = axios.create({
  baseURL: getAPIUrl(),
  // headers: createHeaders(),
});

// const fetchHandler = async (res) => {
//   if (res.status === 200) {
//     return res;
//   }
//   return Promise.reject(res);
// };

// check at our app level (middleware returns a truthy success property)
const checkSuccess = (res) => {
  if (res.status === 200 || res.status === 201) {
    return res;
  }
  return Promise.reject(res);
};

const fetchErrorHandler = (res) => Promise.reject(res);

export class Http {
  // add on params - options = {}, urlPath = 'db'
  createOptions = (url, options) => {
    options.headers = createHeaders();
    return options;
  };

  get(url, queryParams = {}, endpoint = false) {

    return instance({
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY
      },
      url: endpoint ? `${url}` : `${getAPIUrl()}${url}`,
      params: queryParams,
    })
      .then(checkSuccess)
      .catch((e) => fetchErrorHandler(e));
  }

  post(url, body, endpoint = false) {
    if (url === '/winflows_solve_order') {
      return instance({
        method: 'POST',
        url: endpoint ? `${url}` : `${getAPIUrl_solveorder()}${url}`,
        data: body,
      })
        .then(checkSuccess)
        .catch((e) => fetchErrorHandler(e));
    }
    if (url.includes('/winflows_file_save')) {
      return instance({
        method: 'POST',
        headers: {
          'x-api-key': process.env.REACT_APP_X_API_KEY
        },
        url: endpoint ? `${url}` : `${getAPIUrl()}${url}`,
        data: body,
      })
        .then(checkSuccess)
        .catch((e) => fetchErrorHandler(e));
    }
    if (url !== '/winflows_solve_order' && url !== '/winflows_file_save') {
      return instance({
        method: 'POST',
        headers: {
          'x-api-key': process.env.REACT_APP_X_API_KEY
        },
        url: endpoint ? `${url}` : `${getAPIUrl()}${url}`,
        data: body,
      })
        .then(checkSuccess)
        .catch((e) => fetchErrorHandler(e));
    }

    // if (url !== '/winflows_solve_order') {
    //   return instance({
    //     method: 'POST',
    //     url: endpoint ? `${url}` : `${getAPIUrl()}${url}`,
    //     data: body,
    //   })
    //     .then(checkSuccess)
    //     .catch((e) => fetchErrorHandler(e));
    // }
  }

  put(url, body, options = {}, endpoint = false) {
    const putOptions = { method: 'PUT', body: JSON.stringify(body) };
    options = { ...options, ...putOptions };
    return (
      instance({
        method: 'PUT',
        url: endpoint ? `${url}` : `${getAPIUrl()}${url}`,
        data: body,
        headers: {
          ...this.createOptions(url, options),
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      })
        // .then(fetchHandler)
        .then(checkSuccess)
        .catch((e) => fetchErrorHandler(e))
    );
  }

  del(url, queryParams = {}, endpoint = false) {
    return instance({
      method: 'DELETE',
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY
      },
      url: endpoint ? `${url}` : `${getAPIUrl()}${url}`,
      data: queryParams,
    })
      .then(checkSuccess)
      .catch((e) => fetchErrorHandler(e));
  }
}

const httpInstance = new Http();

export default httpInstance;
